import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import PricingRow, { PricingRowDto } from "./PricingRow"
import { PatchRowPayload } from "./row/services"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { PRICING_TABLES } from "../../utils/pricing/constants"

class PricingTableRowService {
    static httpClient: HttpClient<PricingRow, PricingRowDto> = new HttpClient<PricingRow, PricingRowDto>(PricingRow)

    static async updateItem(id: string, documentType: string, payload: PatchRowPayload): Promise<PricingRow | HttpError> {
        if (PRICING_TABLES.includes(documentType)) {
            const res = await AppContext.getApiClient().patch(`/pricing-tables/rows/${id}`, payload)
            if (res && !res.error) {
                return new PricingRow(res)
            }
            return res as HttpError
        }

        const res = await this.httpClient.patch(`/${documentType}-items/${id}`, payload)
        if (isError(res)) {
            return res as HttpError
        }

        return res as PricingRow
    }

    static async getItem(id: string, documentType: string): Promise<PricingRow | HttpError> {
        const res = await this.httpClient.get(`/${documentType}-items/${id}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as PricingRow
    }

    static async deleteItem(id: string, documentType: string, mainObjectId: string): Promise<PricingRow | HttpError> {
        if (PRICING_TABLES.includes(documentType)) {
            const res = await AppContext.getApiClient().delete(`/pricing-tables/${mainObjectId}/rows`, {rowIds: [id]})
            if (res && !res.error) {
                return new PricingRow(res)
            }
            return res as HttpError
        }

        const res = await this.httpClient.delete(`/${documentType}-items/${id}?mainObjectId=${mainObjectId}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as PricingRow
    }

    static async updateItemDiscount(id: string, documentType: string, payload: {
        discountType: string,
        discountValue: string,
        mainObjectId: string
    }) {
        if (PRICING_TABLES.includes(documentType)) {
            const res = await AppContext.getApiClient().put(`/pricing-tables/rows/${id}/discount`, payload)
            if (res && !res.error) {
                return new PricingRow(res)
            }
            return res as HttpError
        }
        return this.httpClient.put(`/${documentType}-items/${id}/discount`, payload)
    }

    static applyBulkUpdate(id: string, payload: object){
        return AppContext.getApiClient().patch(`/pricing-tables/${id}/bulk-update`, payload)
    } 
}

export default PricingTableRowService


// WEBPACK FOOTER //
// ./src/state/pricing/PricingTableRowService.ts